import { factoryService, getJsonRequest, postFormRequest } from '@chilecompra/react-kit/requests'

import { REACT_APP_API_BASE_URL } from '../config/settings/environment.config'

const CLAIMS_API_URL = `${REACT_APP_API_BASE_URL}/v1/api/claims`

/**
 * Fetches claim reasons
 */
export const fetchClaimReasons = factoryService(() =>
  getJsonRequest(`${CLAIMS_API_URL}/types/2/reasons`)
)

/**
 * Fetches the list of available claim types
 */
export const fetchClaimTypes = factoryService(() => getJsonRequest(`${CLAIMS_API_URL}/types`))

/**
 * Fetches organization details associated with a given DNI
 */
export const fetchOrganizationByDni = factoryService(({ dni }) =>
  getJsonRequest(`${CLAIMS_API_URL}/tax-public-org/${dni}`)
)

/**
 * Fetches organization details associated with a given process code
 */
export const fetchOrganizationByProcessCode = factoryService(({ processCode }) =>
  getJsonRequest(`${CLAIMS_API_URL}/process/${processCode}`)
)

/**
 * Submits a new claim along with its attached files
 */
export const submitClaim = factoryService(({ attachedFiles, claim }) =>
  postFormRequest(`${CLAIMS_API_URL}/create-claim`, {
    body: {
      claim: JSON.stringify(claim),
      files: attachedFiles.map(({ file }) => file)
    }
  })
)
